import { api } from "@/api";
import type {
  IPayOutReferralsRequestParams,
  IReferralBankAccounts,
  IReferralsEvent,
  IReferralsStatus,
} from "./types";

export const getReferralsStatus = () =>
  api.get<IReferralsStatus>(`/referrals/status`).then((r) => r.data);

export const getReferralsHistory = () =>
  api
    .get<{ events: IReferralsEvent[] }>(`/referrals/history`)
    .then((r) => r.data.events.reverse());

export const acceptReferralsRules = () =>
  api
    .post<string>(`/referrals/rules-consent`, { accept: true })
    .then((r) => r.data);

export const getReferralsBankAcounts = () =>
  api
    .get<IReferralBankAccounts>(`/referrals/paid-out/bank-accounts`)
    .then((r) => r.data);

export const payOutReferralsReward = (data: IPayOutReferralsRequestParams) =>
  api.post<string>(`/referrals/paid-out`, data).then((r) => r.data);
